// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".num-text[data-v-f34135b0]{opacity:.4;color:#61dbe6;font-weight:700;position:absolute;top:-40px;z-index:1}.num-text-left[data-v-f34135b0]{left:50px}.num-text-right[data-v-f34135b0]{opacity:.4;right:50px}.img-box[data-v-f34135b0]{position:relative;z-index:1}.select-point-title[data-v-f34135b0]{font-weight:700}.feature-select-point-box[data-v-f34135b0]{text-align:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
